import React, { useEffect, useState } from "react";

import "./stylesPlatformOverviewChart.css";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
} from "chart.js";

import RebetLoader from "../../RebetLoader/RebetLoader";

function PlatformOverviewChart({
  isApiPlatformOverviewRunning,
  platformOverviewData,
  isPlatformOverviewSectionFirstRender,
  getPlatformOverviewData
}) {

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const backgroundColorOptions = [
    "#E74C3C",
    "#F39C12",
    "#F1C40F",
    "#71BF8A",
    "#3498DB",
  ];

  const borderColorOptions = [
    "#C0392B",
    "#D68910",
    "#D4AC0D",
    "#58D68D",
    "#2980B9",
  ];

  const keys = Object.keys(platformOverviewData);
  const values = Object.values(platformOverviewData);

  const data = {
    labels: keys,
    datasets: [
      {
        label: "Number of Users",
        data: values,
        backgroundColor: backgroundColorOptions,
        borderColor: borderColorOptions,
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString() + " users",
        color: "white",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
      },
    },
  };

    useEffect(() => {
      if (isPlatformOverviewSectionFirstRender.current) {
        getPlatformOverviewData();
        isPlatformOverviewSectionFirstRender.current = false;
      }
    }, []);

  return (
    <div id="platform-overview-chart">
      <div className="platform-overview-chart-header">
        <h3>Platform Overview</h3>
      </div>
      {isApiPlatformOverviewRunning ? (
        <RebetLoader width="100px" height="100px" />
      ) : (
        <div className="platform-overview-chart-body">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
}

export default PlatformOverviewChart;
